import Pone from '~image/portfolio/portfolio-mas-1.jpg'
import Ptwo from '~image/portfolio/portfolio-mas-13.jpg'
import Pthree from '~image/portfolio/portfolio-mas-4.jpg'
import Pfour from '~image/portfolio/portfolio-mas-6.jpg'
import Pfive from '~image/portfolio/portfolio-mas-8.jpg'
import Psix from '~image/portfolio/portfolio-mas-16.jpg'
import Pseven from '~image/portfolio/portfolio-mas-10.jpg'
import Peight from '~image/portfolio/portfolio-mas-3.jpg'
import Pnine from '~image/portfolio/portfolio-mas-11.jpg'
import Pten from '~image/portfolio/portfolio-mas-2.jpg'
const portfolioData = [
    {
        image:Pone,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"1",
        tagName: ["all","design","seo"]
    },
    {
        image:Ptwo,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"2",
        tagName: ["all","marketing","development"]
    },
    {
        image:Pthree,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"3",
        tagName: ["all","design","marketing"]
    },
    {
        image:Pfour,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"4",
        tagName: ["all","seo"]
    },
    {
        image:Psix,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"6",
        tagName: ["all","design"]
    },
    {
        image:Pseven,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"7",
        tagName: ["all","marketing"]
    },
    {
        image:Pfive,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"5",
        tagName: ["all","seo"]
    },
    {
        image:Peight,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"7",
        tagName: ["all","development"]
    },
    {
        image:Pnine,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"7",
        tagName: ["all","marketing","seo"]
    },
    {
        image:Pten,
        titleSmall:"Agency Brand guide",
        title:"UX and UI, Design",
        id:"7",
        tagName: ["all"]
    },
]
export default portfolioData;